import {IWeldWizardState} from "../../../types/ui/wizard/weld";

export const initialWeldState: IWeldWizardState = {
  calcIds: []
};
